import { TableHeader } from '@popsure/dirty-swan';
import { TableData } from 'components/PrivateQuoteWidget/models';

import {
  renderBoolean,
  renderContribution,
  renderTableCTA,
} from './tableRenderers';

export const getTableHeaders = (): Array<TableHeader<TableData>> => [
  {
    id: 1,
    label: '',
    default: true,
    cells: [
      {
        key: 'name',
        label: 'Our plans',
        render: renderTableCTA({}),
      },
      {
        key: 'contribution',
        label: 'Your contribution',
        render: renderContribution(() => {}),
      },
      {
        key: 'generalDoctor',
        label: "General doctors' visits",
        render: renderBoolean,
      },
      {
        key: 'privateHospitals',
        label: 'Private hospitals',
        render: renderBoolean,
      },
      {
        key: 'worldwideCover',
        label: 'Worldwide cover',
        render: renderBoolean,
      },
    ],
  },
];

export const getTableData = (): Array<Partial<TableData>> => [
  {
    id: 0,
    tariff: 'HiMedical',
    name: 'Standard',
    contribution: '',
    generalDoctor: true,
    privateHospitals: '100%',
    worldwideCover: true,
  },
  {
    id: 1,
    tariff: 'HiMedicalPlus',
    name: 'Premium',
    contribution: '',
    generalDoctor: true,
    privateHospitals: '100%',
    worldwideCover: true,
  },
  {
    id: 3,
    name: 'Public',
    contribution: '',
    generalDoctor: true,
    privateHospitals: false,
    worldwideCover: false,
  },
];
